<script setup>
import FormField from '@/components/shared/form/FormField.vue'
import MultilineTextInput from '@/components/shared/form/MultilineTextInput.vue'
import ActionButton from '@/components/shared/buttons/ActionButton.vue'
import {ref, useTemplateRef} from 'vue'

//Emits and props
const emit = defineEmits([
  'input',
])
defineProps({
  isDisabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: '',
  },
})

//Refs
const text = ref('')

//Send message
const emitInput = () => {

  //No text
  if (!text.value) {
    return
  }

  //Send
  emit('input', {
    text: text.value,
  })

  //Clear ref
  text.value = ''
}

//Component reference
const inputRef = useTemplateRef('inputRef')

//Handle enter key
const handleEnterKey = event => {
  if (event.altKey || event.shiftKey) {
    inputRef.value?.insertText('\n')
  }
  else {
    emitInput()
  }
}
</script>

<template>
  <FormField :class="$style.field">
    <MultilineTextInput
      id="chatInput"
      ref="inputRef"
      v-bind="$attrs"
      :input-class="$style.input"
      :value="text"
      :is-disabled="isDisabled"
      :placeholder="placeholder"
      aria-label="Chat input"
      @input="text = $event.value"
      @keydown.enter.prevent="handleEnterKey($event)"
    >
      <template #inputWrapper>
        <ActionButton
          icon="arrow_upward"
          type="secondary"
          icon-size="s"
          :is-disabled="isDisabled || !text"
          :class="$style.button"
          is-icon-outlined
          is-compact
          @click="emitInput()"
        />
      </template>
    </MultilineTextInput>
  </FormField>
</template>

<style module lang="scss">
.field {
  flex: 0 0 auto;
  margin-top: 1rem !important;
}
.input {
  /* Slightly more roomy */
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  /* For button */
  padding-right: 3rem !important;
}
.button {
  position: absolute;
  bottom: 0.5rem;
  right: 0.5rem;
}
</style>
